export const SET_LIST = "SET_LIST";
export const CLEAR_LIST = "CLEAR_LIST";
export const SET_CURRENT = "SET_CURRENT";
export const SET_ADVISORS_INFO = "SET_ADVISORS_INFO";
export const SET_INTERMEDIARY_LIST = "SET_INTERMEDIARY_LIST";
export const SET_MATCH_LIST = "SET_MATCH_LIST";
